import script from "./OtpInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpInput.vue?vue&type=script&setup=true&lang=js"

import "./OtpInput.vue?vue&type=style&index=0&id=2149fbf1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2149fbf1"]])

export default __exports__